export const authBotActiveSelector = ({ chatBot }: any) =>
    chatBot?.authBotActive;
